import {
  base_colorContentBorder,
  base_colorContentBorderSecondary,
  base_colorRaisedSurface,
  tag_colorTagDefaultBackground,
  tag_colorTagDefaultText,
  tag_colorTagHighlightBackground,
  tag_colorTagHighlightText,
  tag_colorTagNewText,
  tag_colorTagPendingBackground,
  tag_colorTagPendingText,
  tag_colorTagSevereBackground,
  tag_colorTagSevereText,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { cornerRadius, spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_md,
  font_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export const receiptRecoveryHeaderStyle = css`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .ReceiptRecoverySection--header-label {
    display: flex;
    align-items: center;
    gap: ${spacing(2)};

    .font-h3 {
      color: #1e2c4c;
    }
  }
`

export default css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(3)};

  .ReceiptRecoverySection--agent-context,
  .ReceiptRecoverySection--case,
  .ReceiptRecoverySection--waiting,
  .ReceiptRecoverySection--waiting-activity,
  .ReceiptRecoverySection--waiting-activity-content {
    display: flex;
    flex-direction: column;
  }

  .ReceiptRecoverySection--case {
    gap: ${spacing(4)};
    padding: ${spacing(5)};
    border: 1px solid ${base_colorContentBorder};
    border-radius: ${cornerRadius};
    background: ${base_colorRaisedSurface};
  }

  .ReceiptRecoverySection--status-row {
    display: flex;
    align-self: flex-start;
  }

  .ReceiptRecoverySection--waiting {
    gap: ${spacing(4)};
  }

  .ReceiptRecoverySection--waiting-activity {
    gap: ${spacing(2)};
  }

  .ReceiptRecoverySection--waiting-activity-content {
    gap: ${spacing(1)};
    padding-left: ${spacing(8)};
  }

  .ReceiptRecoverySection--status-row-compact {
    width: 100%;
    align-items: center;
    gap: ${spacing(2)};
  }

  .ReceiptRecoverySection--status-pill {
    &.default:hover {
      background: ${tag_colorTagDefaultBackground};
      color: ${tag_colorTagDefaultText};
    }

    &.highlight:hover {
      background: ${tag_colorTagHighlightBackground};
      color: ${tag_colorTagHighlightText};
    }

    &.pending:hover {
      background: ${tag_colorTagPendingBackground};
      color: ${tag_colorTagPendingText};
    }

    &.severe:hover {
      background: ${tag_colorTagSevereBackground};
      color: ${tag_colorTagSevereText};
    }
  }

  .ReceiptRecoverySection--header-actions,
  .ReceiptRecoverySection--mock-preview-controls,
  .ReceiptRecoverySection--mock-preview-navigation {
    display: flex;
    align-items: center;
  }

  .ReceiptRecoverySection--header-actions {
    gap: ${spacing(2)};
  }

  .ReceiptRecoverySection--mock-preview-controls {
    gap: ${spacing(1)};
  }

  .ReceiptRecoverySection--mock-preview-navigation {
    gap: ${spacing(0.5)};
  }

  .ReceiptRecoverySection--mock-preview-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    padding: 0;
    border: 1px solid ${base_colorContentBorder};
    border-radius: ${spacing(1)};
    background: ${base_colorRaisedSurface};
    cursor: pointer;

    svg {
      width: 16px;
      height: 16px;

      path {
        fill: ${text_colorTextSecondary};
      }
    }
  }

  .ReceiptRecoverySection--agent-context {
    gap: ${spacing(2)};
  }

  .ReceiptRecoverySection--agent-provenance {
    display: flex;
    align-items: center;
    gap: ${spacing(2)};
  }

  .ReceiptRecoverySection--agent-label {
    color: #1e2c4c;
    font-family: ${font_family_weight_medium};
    ${font_sm}
  }

  .ReceiptRecoverySection--agent-meta {
    flex: 1;
    min-width: 0;
    color: ${text_colorTextSecondary};
    font-family: ${font_family_weight_regular};
    ${font_sm}
  }

  .ReceiptRecoverySection--agent-avatar {
    position: relative;
    display: inline-flex;
    flex: none;
    align-items: center;
    justify-content: center;
    width: ${spacing(6)};
    height: ${spacing(6)};
    border-radius: 50%;
    background: #1e2c4c;
  }

  .ReceiptRecoverySection--agent-avatar-logo {
    width: ${spacing(3)};
    height: ${spacing(3)};
  }

  .ReceiptRecoverySection--agent-avatar-sparkle {
    position: absolute;
    top: 15.33px;
    left: 15.33px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 10.08px;
    height: 10.08px;
    box-sizing: content-box;
    border: 1.2px solid ${base_colorContentBorderSecondary};
    border-radius: 50%;
    background: ${tag_colorTagNewText};
    overflow: hidden;
  }

  .ReceiptRecoverySection--agent-avatar-sparkle-artwork {
    position: absolute;
    top: 1.01px;
    left: 1.01px;
    display: grid;
    width: 8.064px;
    height: 8.064px;
    box-sizing: border-box;
    place-items: center;
    padding: 8.33%;
    overflow: hidden;
  }

  .ReceiptRecoverySection--agent-avatar-sparkle-artwork img {
    display: block;
    width: 100%;
    height: 100%;
  }

  .ReceiptRecoverySection--description {
    margin: 0;
    color: #1e2c4c;
    font-family: ${font_family_weight_regular};
    ${font_md}
  }

  .ReceiptRecoverySection--activity-title {
    margin: 0;
    color: #1e2c4c;
    font-family: ${font_family_weight_medium};
    ${font_md}
  }

  .ReceiptRecoverySection--review {
    display: flex;
    flex-direction: column;
    gap: ${spacing(2)};
    padding-top: ${spacing(4)};
    border-top: 1px solid ${base_colorContentBorder};
  }

  .ReceiptRecoverySection--review-options {
    margin: 0;
    padding: 0;

    legend {
      margin-bottom: ${spacing(2)};
      color: #1e2c4c;
      font-family: ${font_family_weight_medium};
      ${font_md}
    }

    .RadioGroup--buttons {
      gap: ${spacing(2)};

      label.RadioButton {
        gap: ${spacing(3)};
        padding: ${spacing(3)} ${spacing(4)};

        & .RadioButton--title {
          margin-bottom: ${spacing(0.5)};
          ${font_md}
        }

        & .RadioButton--desc {
          ${font_sm}
        }
      }
    }
  }

  .ReceiptRecoverySection--submit-row {
    display: flex;
    align-items: center;
    gap: ${spacing(3)};
  }

  .ReceiptRecoverySection--submit-note {
    flex: 1;
    margin: 0;
    color: ${text_colorTextSecondary};
    font-family: ${font_family_weight_regular};
    ${font_sm}
  }

  .ReceiptRecoverySection--submit {
    flex: none;
    margin-left: auto;
  }
`
